import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import NavBar from "../components/NavBar";
import Distributor from "../pages/Distributor/Distributor";
import useMenu from "../utils/Hooks/useMenu";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.Distributor,
    key: "Distributor",
  };

  return (
    <LocalizationContext.Provider value={null}>
      <ValidateURL currentPage={currentPage}>
        <NavBar
          MenuOptions={menu}
          currentPage={currentPage}
        >
          <Distributor />
        </NavBar>
      </ValidateURL>
    </LocalizationContext.Provider>
  );
};
